import { render, staticRenderFns } from "./addMember.vue?vue&type=template&id=b476582e&"
import script from "./addMember.vue?vue&type=script&lang=js&"
export * from "./addMember.vue?vue&type=script&lang=js&"
import style0 from "./addMember.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports